// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/documents/actions';
import { filterShapes, themesById, classify } from '../state/documents/reducer';
import { withRouter } from 'react-router';

// Components
import Document from '../components/Documents/Document';

function mapStateToProps(state) {
	return {
		document: state.documents.current,
		selected: state.documents.selected,
		upload: state.documents.upload,
		hasEdited: state.documents.hasEdited,
		isFetchingMap: state.documents.isFetchingMap,
		salvarBtEnabled: state.documents.salvarBtEnabled,
		nextPage: state.documents.nextPage,
		selectedShapes: filterShapes(state.documents.current),
		themesById: themesById(state.documents.current),
		existentAndNew: classify(state.documents.current),
		userProjectAccess: state.login.projectaccess,
		userGroupAccess: state.login.groupaccess,
		isProcessingZip: state.documents.isProcessingZip
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Document));


// WEBPACK FOOTER //
// ./src/containers/DocumentContainer.js